import React from 'react';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import {SMCCheckbox} from '../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Indentation from '../../../components/Simple/Indentation';

function ExportSMPStepOne({
    onCancel,
    onNext,
    pageParams
}) {
    const { t } = useTranslation();

    const {
        isExportFirmware, setIsExportFirmware,
        isExportAdministrators, setIsExportAdministrators,
        isExportSystemSettings, setIsExportSystemSettings
    } = pageParams;

    return (
        <>
        <SMCModalBody lineHeight="28px">
            <SMCLabel bold fontSize="15px">{t('SMC_SYSOPS_EXPWIZ_HEAD1')}</SMCLabel>
            <SMCLabel>{t('SMC_SYSOPS_EXPWIZ_TEXT')}</SMCLabel>
            <Indentation>
                <SMCCheckbox
                    checked={isExportFirmware}
                    onChange={e => setIsExportFirmware(e.target.checked)}
                    label={t('SMC_SYSOPS_EXPWIZ_FIRMS')}
                />
                <SMCCheckbox
                    checked={isExportAdministrators}
                    onChange={e => setIsExportAdministrators(e.target.checked)}
                    label={t('SMC_SYSOPS_EXPWIZ_ADMINS')}
                />
                <SMCCheckbox
                    checked={isExportSystemSettings}
                    onChange={e => setIsExportSystemSettings(e.target.checked)}
                    label={t('SMC_SYSOPS_EXPWIZ_SYS')}
                />
            </Indentation>
        </SMCModalBody>
        <SMCModalButtonContainer>
            <SMCButton onClick={onNext}>
                {t('SMC_GEN_WIZNEXT')}
                <FontAwesomeIcon style={{ marginTop: '3px', marginLeft: '5px' }} color="grey" icon="arrow-circle-right" />
            </SMCButton>
            <SMCButton onClick={onCancel}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                {t('SMC_GEN_CANCEL')}
            </SMCButton>
        </SMCModalButtonContainer>
        </>
    )
}

export default ExportSMPStepOne;